import {ErrorHandler, Inject, Injectable} from '@angular/core';
import {WINDOW} from '@app/services/window.service';

@Injectable({providedIn: 'root'})
export class AppGlobalErrorHandler implements ErrorHandler {
	constructor(
		@Inject(WINDOW) private window: Window
	) {
	}

	handleError(error) {
		console.error(error);
		if (this.window['newrelic']) {
			this.window['newrelic'].noticeError(error);
		}
	}
}
